import React from 'react'
import { ctcActivity } from '../services/merpservices';
import { decryptPII } from '../utils/encryption/aesEncryption';
import { gaEvent } from '../utils/GoogleAnalytics/gatracking';
import { Alert } from '../utils/Alert';

const PostBuyLeadPopup = ({empid, ak, glid, descriptionValue, handleDisableBtn}) => {

    const buylead_Window = () => {
        if (descriptionValue === "") {
            Alert("Kindly fill the disposition first");
            return false;
        }
        const urlParams = new URLSearchParams(window.location.search);
        // Decrypt phone parameter (supports both encrypted and unencrypted for backward compatibility)
        const number = decryptPII(urlParams.get('phone') || "");
        const ucid = urlParams.get('crtObjectId')
        try {
            const res = ctcActivity(empid, ak, ucid, 1 )
        } catch (error) {
            console.log(error)
        }
        
        window.open('http://leap.intermesh.net/brf/index.php?modid=LEAPIN&pns=1&mobile=' + number + '&glusrid=' + glid, '_blank', 'toolbar=yes, scrollbars=yes, resizable=yes, top=5, left=5, width=1024, height=600')
    }

    return (
        <>
            <span 
                style={{backgroundColor: `${handleDisableBtn === true ? 'lightgray' : ''}`}}
                onClick={()=>{handleDisableBtn !== true && buylead_Window(); gaEvent(
                'Post BuyLead New',
                'Post BuyLead New',
                'Post BuyLead New'
            )}}>Post Buylead</span>
        </>
    )
}

export default PostBuyLeadPopup;